import React from "react";
import axios from 'axios';
import ImageGallery from 'react-image-gallery';

class CongressCallery extends React.Component {

    state = {
        images: null,
        //id: "TdepkTTogxjQxrEQ7"
    }

    async componentDidMount() {
        const { id } = this.state;
        const { response } = this.props;
        const { galleryId } = this.props;
      //  console.log(response);
        const localphotos = 'http://localhost:3000/photos';
        const serverphotos = 'http://www.45zfp.uj.edu.pl/photos'

        if (response && response.data && response.data.length > 0) {
            this.setState({
                images: response.data.map((url: string) => ({
                    original: `${serverphotos}/large/${galleryId}/${url}`,
                    thumbnail: `${serverphotos}/small/${galleryId}/${url}`,
                })),
            })
        }
    }

    render() {
        const {images} = this.state;
        return images ? <ImageGallery items={images}/> : <h3>Ładowanie galerii...</h3>
    }
}
export default CongressCallery
